import React from "react";
//import { Link } from "react-router-dom";
import Male from "./srilanka-male.jsx";
import "./srilanka.css";

// import srilanka from "../../../../../assets/Sri-Lanka-2.png";
// import banglades from "../../../../../assets/bangladesh.png";
// import vietnam from "../../../../../assets/vietnam.png";
// import ethiopia from "../../../../../assets/Ethiopia-flag.png";

export default function Srilanka() {

  return (
    <div style={{ width: "100%" }}>
      <div>
        <div className="empower-chart-4-srilanka-paragraph-two-column">
          <div className="empower-chart-4-srilanka-paragraph-column-1 career-development-empower-chart-4-srilanka-paragraph-column-1">
            <div className="aa-mobile">
              <p className="gender-topic">Gender</p>
            </div>
          </div>
          <div className="empower-chart-4-srilanka-paragraph-column-2 career-development-empower-chart-4-srilanka-paragraph-column-2">
            <div>{<Male />}</div>
          </div>
          <div className="empower-chart-4-srilanka-paragraph-column-3">
            <center>
              <div>
                <br />
                <div className="chart-7-flag selected">
                  {/* <img src={ethiopia} alt="1" /> */}
                  <h3 className="selected">Ethiopia</h3>
                </div>
                <br />
                <div className="chart-7-flag selected">
                  {/* <img src={vietnam} alt="1" /> */}
                  <h3 className="selected">Vietnam</h3>
                </div>
                <br />
                <div className="chart-7-flag selected">
                  {/* <img src={banglades} alt="1" /> */}
                  <h3 className="selected">Bangladesh</h3>
                </div>
                <br />
                <div className="chart-7-flag selected">
                  {/* <img src={srilanka} alt="1" /> */}
                  <h3 className="selected">Sri Lanka</h3>
                </div>
              </div>
            </center>
          </div>
        </div>
      </div>
      <div className="aa-pc">
        <div style={{ marginTop: "-20px" }}>
          <div className="empower-chart-4-srilanka-paragraph-two-column">
            <div className="empower-chart-4-srilanka-paragraph-column-4 career-development-empower-chart-4-srilanka-paragraph-column-4"></div>
            <div className="empower-chart-4-srilanka-paragraph-column-5 career-development-empower-chart-4-srilanka-paragraph-column-5"></div>
            <div className="empower-chart-4-srilanka-paragraph-column-6">
              <br />
              <p className="gender-topic">Country</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
